import Footer from "../Fotter";

const AboutUs = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        <div className=" mx-auto px-4 py-6">
          <h2 className="text-5xl font-semibold text-center text-gray-800 mb-6">
            About Us
          </h2>

          <p className="text-lg text-gray-700 mb-6">
            We are India’s Shopping portal based in India , Delivering Products only in India and this portal has most of the products from Indian Manufactures.
          </p>

          <p className="text-lg text-gray-700 mb-6">Fliptwirls stands as a distinguished online shopping portal
            in India, meticulously crafted to revolutionize the shopping experience for discerning consumers
            throughout the nation. Exclusively serving the Indian market, Fliptwirls offers an extensive array
            of high-quality products sourced from reputable local manufacturers, thereby celebrating the richness and
            diversity of Indian craftsmanship and innovation.
          </p>

          <p className="text-lg text-gray-700 mb-6">This platform is committed to fostering a seamless shopping journey that prioritizes customer satisfaction and convenience. With a focus on empowering local businesses, Fliptwirls champions the spirit of entrepreneurship while providing consumers with access to exceptional products that reflect the best of Indian artistry.
          </p>

          <p className="text-lg text-gray-700 mb-6">In a rapidly evolving digital landscape, Fliptwirls is dedicated to maintaining the highest standards of service and quality. The commitment to excellence is evident in every aspect of the shopping experience, from user-friendly navigation and secure payment processes to responsive customer support that operates around the clock.
          </p>

          <p className="text-lg text-gray-700 mb-6">Choosing Fliptwirls means engaging with a platform that values integrity, affordability, and the empowerment of the local economy. Each purchase contributes not only to personal satisfaction but also supports the growth of businesses that are vital to India’s economic fabric..
          </p>

          <p className="text-lg text-gray-700 mb-6">Thank you for choosing Fliptwirls, where a steadfast commitment to excellence and authenticity defines every aspect of the shopping experience.
          </p>

          <strong>Key Features:</strong>

          <li>
            <strong>Cash on Delivery:</strong> A secure payment option that enhances customer confidence by allowing purchases to be inspected prior to payment.
          </li>

          <li>
            <strong>24/7 Customer Service</strong> A dedicated support team available around the clock to promptly address inquiries and provide assistance, ensuring a seamless shopping experience.
          </li>

          <li>
            <strong>Quality Assurance: </strong> Stringent quality control measures ensure that customers receive only the finest products that meet high standards of excellence.
          </li>

          <li>
            <strong>Easy Refunds and Returns:</strong> A straightforward return policy facilitates hassle-free refunds and exchanges, guaranteeing complete satisfaction.
          </li>


          <p className="text-lg text-gray-700 mb-6 mt-10">
            Company :- Green Web Software Development P. Ltd
          </p>

          <ul className="list-inside pl-5 space-y-2 text-lg text-gray-700">
            <li>
              <strong>Registration Number:</strong> U72200MP2010PTC024981
            </li>
            <li>
              <strong>Address:</strong> Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001
            </li>
            <li>
              <strong>Registered Address Building No./Flat No.:12 ,THAKUR JI KI HAWELI JALPA MATA MANDIR ROAD RAJGARH Rajgarh Madhya Pradesh, Pin 465661
              </strong>
              <strong>Email:</strong>  info@fliptwirls.com  ( We try to reply every Query Within 24 working hours )
            </li>
            <li>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.fliptwirls.com"
                className="text-blue-500 hover:underline"
              >
                www.fliptwirls.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
